import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import CommentDetails from './components/CommentDetails';
import AttachmentDetails from './components/AttachmentDetails';
import ChangesetDetails from './components/ChangesetDetails';
import { channelItemsType } from '../../../../../../constants/proptype-validation';
import classnames from 'classnames';
import { channelItemTypes } from '../../../../../../constants/channel-items';

// eslint-disable-next-line consistent-return
const ChannelItem = ({ item, isLast } = {}) => {
  switch (item.type) {
    case channelItemTypes.COMMENTS:
      return <CommentDetails isLast={isLast} comment={item} />;
    case channelItemTypes.ATTACHMENTS:
      return <AttachmentDetails isLast={isLast} attachment={item} />;
    case channelItemTypes.CHANGESETS:
      return <ChangesetDetails isLast={isLast} changeset={item} />;
    default:
      return null;
  }
};
ChannelItem.displayName = 'ChannelItem';
ChannelItem.propTypes = {
  item: PropTypes.object.isRequired,
  isLast: PropTypes.bool.isRequired,
};

class ChannelItems extends PureComponent {

  componentDidMount() {
    this._scrollToBottom();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.channelItems.length !== this.props.channelItems.length) {
      this._scrollToBottom();
    }
  }

  _scrollToBottom() {
    if (this.mainDiv) {
      this.mainDiv.scrollTop = this.mainDiv.scrollHeight;
    }
  }

  getItems() {
    const { channelItems } = this.props;
    const lastIndex = channelItems.length - 1;
    return (
      <div className="isui-channel-items">
        {channelItems.map((item, index) => {
          return (
            <div key={item.id} className="isui-channel-item">
              <ChannelItem item={item} isLast={index === lastIndex} />
            </div>
          );
        })}
      </div>
    );
  }

  render() {
    const { className } = this.props;

    const channelClassName = classnames('isui-channel', className || '');

    return (
      <div className={channelClassName} ref={(div) => { this.mainDiv = div; }}>
        {this.getItems()}
      </div>
    );
  }

}
ChannelItems.displayName = 'ChannelItems';
ChannelItems.propTypes = {
  issueId: PropTypes.string.isRequired,
  channelItems: channelItemsType.isRequired,
  className: PropTypes.string,
};

export default ChannelItems;
